import { genericGet } from "../../../services/api.service";
import { EntityConfig } from "../../../types/EntityConfig";


export const OperacoesConfig: EntityConfig = [
  {
    id: 'id',
    label: 'Id',
    nonEditable: true,
    type: 'id',
    hidden: true
  },
  {
    id: 'tipo',
    label: 'Tipo',
    type: 'enum',
    options: {
      route: 'state',
      getter: async () => (await genericGet('/pecas/operacoes/tipos')).filter((t : string) => t != 'Expedição'),
    }
  },
  {
    id: 'observacoes',
    label: 'Observações',
    type: 'text'
  },
  {
      id: 'medida',
      label: 'Medida',
      type: 'text',
      conditional : (form: any, parentIndex: number, index: number) => {
        return form?.state?.pecas[parentIndex] ? form?.state?.pecas[parentIndex].operacoes[index].tipo === 'Serrote' : false;
      }
  },
  {
    id: 'isExternal',
    label: 'Operação externa',
    type: 'boolean',
    filterable: true,
  },
  {
    id: 'dataExpedicao',
    label: 'Data de saída',
    type: 'date',
    conditional: (form: any, parentIndex: number, index: number) => {

      return form?.state?.pecas[parentIndex] ? form?.state?.pecas[parentIndex].operacoes[index].isExternal : false;
     
    }
  }

]



